





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import { createPopper, Instance, Placement } from '@popperjs/core'
// @ts-ignore
import _, { DebouncedFunc } from 'lodash'
import { Mentionable } from '@/models/Group/Member'

@Component
export default class InputSearchMention extends Vue {
  @Prop({ default: () => [] }) listToSearch!: Mentionable[]
  @Prop({ default: 'bottom-start' }) popupPosition!: Placement
  @Prop({ default: 'top-start' }) popupFallbackPosition!: Placement
  @Prop({ default: false }) needFallbackPosition!: boolean
  private debouncedSearchToMention!: DebouncedFunc<() => void>

  noAvatar = require('@/assets/images/avatar-default.png')
  searchMember = ''
  isOpen = false
  popperInstance!: Instance | null

  $refs!: {
    inputRef: HTMLInputElement
    dropdownRef: HTMLElement
  }

  @Watch('listToSearch')
  watchListChange() {
    if (this.listToSearch.length > 0) {
      this.openDropdown()
    } else {
      this.closeDropdown()
    }
  }

  created() {
    this.debouncedSearchToMention = _.debounce(this.handleSearchMember, 300)
  }

  mounted() {
    window.addEventListener('resize', this.updatePosition)
    window.addEventListener('scroll', this.updatePosition, true)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePosition)
    window.removeEventListener('scroll', this.updatePosition, true)
    this.popperInstance?.destroy()
  }

  clearSearch() {
    this.searchMember = ''
  }

  createPopperInstance() {
    if (!this.$refs.inputRef || !this.$refs.dropdownRef) return
    if (this.popperInstance) {
      this.popperInstance.destroy()
    }
    this.popperInstance = createPopper(
      this.$refs.inputRef,
      this.$refs.dropdownRef,
      {
        placement: this.popupPosition,
        modifiers: [
          { name: 'offset', options: { offset: [0, 4] } },
          ...(this.needFallbackPosition
            ? [
                {
                  name: 'flip',
                  options: { fallbackPlacements: [this.popupFallbackPosition] }
                }
              ]
            : [])
        ]
      }
    )
  }

  openDropdown() {
    if (this.listToSearch.length === 0) return

    this.isOpen = true
    this.$nextTick(() => {
      if (this.$refs.dropdownRef) {
        this.$refs.dropdownRef.style.visibility = 'hidden'
        this.createPopperInstance()
        this.updatePosition()
        this.$refs.dropdownRef.style.visibility = 'visible'
      }
    })
  }

  closeDropdown() {
    this.isOpen = false
  }

  updatePosition = () => {
    this.$nextTick(() => {
      this.popperInstance?.update()
    })
  }

  onSearchMember() {
    this.debouncedSearchToMention()
  }

  handleSearchMember() {
    if (!this.searchMember.trim()) {
      this.isOpen = false
      this.$emit('clearListToSearch')
    } else {
      this.$emit('onSearch', this.searchMember)
    }
  }

  onSelectItem(item: Mentionable) {
    this.$emit('onSelect', item)
  }
}
